import { type ReactNode } from 'react';
import { FieldWrapper } from './FieldWrapper';

type ReadOnlyFieldProps = {
  label: ReactNode;
  value: string;
  appearance?: 'default' | 'design-system';
};

export const ReadOnlyField = ({
  label,
  value,
  appearance = 'default',
}: ReadOnlyFieldProps) => (
  <FieldWrapper label={label} appearance={appearance}>
    <div
      role="textbox"
      aria-readonly="true"
      data-field-appearance={appearance}
      className={
        appearance === 'design-system'
          ? 'flex min-h-11 w-full items-center break-all rounded-xl border-[1.5px] border-rw-neutral-lighter-gray bg-rw-neutral-off-white p-2.5 text-base leading-6 text-rw-neutral-dark-gray opacity-60'
          : 'min-h-10 w-full break-all rounded-md border border-gray-300 bg-gray-100 px-4 py-2 text-sm text-gray-700 shadow-sm'
      }
    >
      {value}
    </div>
  </FieldWrapper>
);
